/* global $ */
var Proj = (function(proj){
    'use strict';


    function hideAllVariants() {
        $('.js-cat-items').find('span').css('transform', '').html('>');
        $('.cat_group__item').removeClass('m--active');
        $('.cat_group__items').removeClass('m--active');
        $('.cat_group__items').each(function() {
            if ($(this).find('.cat_subgroup_item').length > 0) {
                $(this).find('.variants').slideUp(300).html("");
            } else {
                $(this).find('.variants').slideUp(300).find('.variants__main').html("");
            }
        });
    }

    function showVariants() {
        $('.js-cat-items').click(function(){
            var $parent_item = $(this).closest('.cat_group__item');
            var $variants_group = $(this).closest('.cat_group__items').find('.variants');
            $('.js-cat-items').find('span').css('transform', '').html('>');
            if (!$parent_item.hasClass('m--active')) {
                if ($('.js-is_big_mobile').css('display') != 'none' || $('.header__mobile').css('display') != 'none' ) {
                    if ($parent_item.index() < 2) {
                        $variants_group.css('top','50%');
                    } else {
                        $variants_group.css('top','');
                    }
                } else {
                    $variants_group.css('top','');
                }
                $(this).find('span').css('transform', 'none').html('x');
                $variants_group.html("");
                $parent_item.parent().find('.cat_group__item').removeClass('m--active');
                $parent_item.addClass('m--active');
                $variants_group.append($(this).siblings(".variants__items").html()).slideDown(300);
            }
            else {
                $(this).find('span').css('transform', '').html('>');
                $variants_group.slideUp(300).html("");
                $parent_item.removeClass('m--active');
            }
        })
    }


    function hideVariants () {
        $(window).click(function(){
            hideAllVariants();
        });
        $('.cat_group__item').click(function(event){
            event.stopPropagation();
        });
        $('.variants.m--products').click(function(event){
            event.stopPropagation();
        });
        $('.cat_group__items').find('.variants__main').click(function(event){
            event.stopPropagation();
        });
        $('.js-cat-more').click(function(event){
            event.stopPropagation();
        });
    }

    proj.Variants = function(){
        showVariants();
        hideVariants();
    };

    return proj;
})(Proj || {});



